import { render, staticRenderFns } from "./registro_usuario.vue?vue&type=template&id=a8f8c78e&scoped=true"
import script from "./registro_usuario.vue?vue&type=script&lang=js"
export * from "./registro_usuario.vue?vue&type=script&lang=js"
import style0 from "./registro_usuario.vue?vue&type=style&index=0&id=a8f8c78e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8f8c78e",
  null
  
)

export default component.exports